import moment from "moment";

export default function parseDate(str) {
  const m = moment(str, "YYYY-MM-DD", true);
  const [year, month, date] = m.toArray();
  return { year, month, date };
}
